"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _user = _interopRequireDefault(require("@/api/system/user"));

var _userLists = _interopRequireWildcard(require("@/api/userLists"));

var _data = require("@/api/data");

var _validate = require("@/utils/validate");

var _dept = require("@/api/system/dept");

var _role = require("@/api/system/role");

var _job = require("@/api/system/job");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

var _vuex = require("vuex");

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var userRoles = [];
var userJobs = [];
var defaultForm = {
  id: null,
  username: null,
  nickName: null,
  gender: '男',
  email: null,
  enabled: 'false',
  roles: [],
  jobs: [],
  dept: {
    id: null
  },
  phone: null
};
var _default = {
  name: 'User',
  components: {
    Treeselect: _vueTreeselect.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    pagination: _Pagination.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '用户',
      url: 'api/users',
      crudMethod: _objectSpread({}, _user.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  // 数据字典
  dicts: ['user_status'],
  data: function data() {
    // 自定义验证
    var validPhone = function validPhone(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!(0, _validate.isvalidPhone)(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };

    return {
      normalizer: function normalizer(node) {
        //方法
        return {
          id: node.name,
          // 键名转换，方法默认是label和children进行树状渲染
          label: node.name,
          children: node.children
        };
      },
      height: document.documentElement.clientHeight - 180 + 'px;',
      deptName: '',
      depts: [],
      deptDatas: [],
      jobs: [],
      level: 3,
      roles: [],
      deptDatas0: [],
      deptDatas1: [],
      deptDatas2: [],
      deptDatas3: [],
      deptDatas4: [],
      deptDatas5: [],
      deptDatas6: [],
      deptDatas7: [],
      deptDatas8: [],
      deptDatas9: [],
      deptDatas10: [],
      deptDatas11: [],
      deptDatas12: [],
      deptDatas13: [],
      deptDatas14: [],
      deptDatas15: [],
      jobDatas: [],
      roleDatas: [],
      // 多选时使用
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      userListsId: 0,
      userId: 0,
      deptId: 0,
      loading: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  mounted: function mounted() {
    var that = this;

    window.onresize = function temp() {
      that.height = document.documentElement.clientHeight - 180 + 'px;';
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    this.getDepts();
    return true;
  }), (0, _defineProperty2.default)(_methods, "selectUser", function selectUser(row) {
    var _this2 = this;

    console.log('selectUser');
    console.log(row);

    if (row) {
      console.log(row);
      var that = this;
      that.deptId = 0;
      that.reset();
      (0, _data.initData)('api/userLists/get', {
        userId: row.id
      }).then(function (data) {
        that.userId = row.id;

        if (data) {
          that.userListsId = data.id;
          var typeDepts = JSON.parse(data.typeDepts);
          _this2.deptDatas0 = typeDepts['推广'];
          _this2.deptDatas1 = typeDepts['客服'];
          _this2.deptDatas12 = typeDepts['资调'];
          _this2.deptDatas8 = typeDepts['门店店长'];
          _this2.deptDatas2 = typeDepts['门店导购'];
          _this2.deptDatas3 = typeDepts['设计师'];
          _this2.deptDatas13 = typeDepts['效果图组主管'];
          _this2.deptDatas14 = typeDepts['效果图组对接人'];
          _this2.deptDatas11 = typeDepts['协助设计师'];
          _this2.deptDatas9 = typeDepts['设计主管'];
          _this2.deptDatas10 = typeDepts['设计对接人'];
          _this2.deptDatas4 = typeDepts['设计中心派单员'];
          _this2.deptDatas5 = typeDepts['设计审单员'];
          _this2.deptDatas15 = typeDepts['下单员'];
          _this2.deptDatas6 = typeDepts['配送'];
          _this2.deptDatas7 = typeDepts['安装'];
        }
      });
    } // crudUserLists.get({'type':'dwef','userId':'1L'}).then(res => {
    //   that.userId = row.id
    //   console.log(res)
    // })

  }), (0, _defineProperty2.default)(_methods, "changeRole", function changeRole(value) {
    userRoles = [];
    value.forEach(function (data, index) {
      var role = {
        id: data
      };
      userRoles.push(role);
    });
  }), (0, _defineProperty2.default)(_methods, "changeJob", function changeJob(value) {
    userJobs = [];
    value.forEach(function (data, index) {
      var job = {
        id: data
      };
      userJobs.push(job);
    });
  }), (0, _defineProperty2.default)(_methods, "deleteTag", function deleteTag(value) {
    userRoles.forEach(function (data, index) {
      if (data.id === value) {
        userRoles.splice(index2, value);
      }
    });
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToCU, function (crud, form) {
    this.getRoles();

    if (form.id == null) {
      this.getDepts();
    } else {
      this.getSupDepts(form.dept.id);
    }

    this.getRoleLevel();
    this.getJobs();
    form.enabled = form.enabled.toString();
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToAdd, function () {
    this.jobDatas = [];
    this.roleDatas = [];
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (crud, form) {
    this.getJobs(this.form.dept.id);
    this.jobDatas = [];
    this.roleDatas = [];
    userRoles = [];
    userJobs = [];

    var _this = this;

    form.roles.forEach(function (role, index) {
      _this.roleDatas.push(role.id);

      var rol = {
        id: role.id
      };
      userRoles.push(rol);
    });
    form.jobs.forEach(function (job, index) {
      _this.jobDatas.push(job.id);

      var data = {
        id: job.id
      };
      userJobs.push(data);
    });
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterValidateCU, function (crud) {
    if (!crud.form.dept.id) {
      this.$message({
        message: '部门不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.jobDatas.length === 0) {
      this.$message({
        message: '岗位不能为空',
        type: 'warning'
      });
      return false;
    } else if (this.roleDatas.length === 0) {
      this.$message({
        message: '角色不能为空',
        type: 'warning'
      });
      return false;
    }

    crud.form.roles = userRoles;
    crud.form.jobs = userJobs;
    return true;
  }), (0, _defineProperty2.default)(_methods, "getDeptDatas", function getDeptDatas(node, resolve) {
    var _this3 = this;

    var sort = 'id,desc';
    var params = {
      sort: sort
    };

    if ((0, _typeof2.default)(node) !== 'object') {
      if (node) {
        params['name'] = node;
      }
    } else if (node.level !== 0) {
      params['pid'] = node.data.id;
    }

    setTimeout(function () {
      (0, _dept.getDepts)(params).then(function (res) {
        if (resolve) {
          resolve(res.content);
        } else {
          _this3.deptDatas = res.content;
        }
      });
    }, 100);
  }), (0, _defineProperty2.default)(_methods, "handleNodeClick", function handleNodeClick(data) {
    console.log('handleNodeClick1');
    var that = this;
    this.userId = 0;
    this.reset();

    if (data.pid === 0) {
      this.query.deptId = null;
      this.deptId = 0;
    } else {
      this.query.deptId = data.id;
      this.deptId = data.id;
      this.crud.toQuery();
      (0, _data.initData)('api/userLists/deptGet', {
        deptId: data.id
      }).then(function (data) {
        if (data) {
          var typeDepts = JSON.parse(data.typeDepts);
          that.userListsId = data.id;
          that.deptDatas0 = typeDepts['推广'];
          that.deptDatas1 = typeDepts['客服'];
          that.deptDatas12 = typeDepts['资调'];
          that.deptDatas8 = typeDepts['门店店长'];
          that.deptDatas2 = typeDepts['门店导购'];
          that.deptDatas3 = typeDepts['设计师'];
          that.deptDatas13 = typeDepts['效果图组主管'];
          that.deptDatas14 = typeDepts['效果图组对接人'];
          that.deptDatas11 = typeDepts['协助设计师'];
          that.deptDatas9 = typeDepts['设计主管'];
          that.deptDatas10 = typeDepts['设计对接人'];
          that.deptDatas4 = typeDepts['设计中心派单员'];
          that.deptDatas5 = typeDepts['设计审单员'];
          that.deptDatas15 = typeDepts['下单员'];
          that.deptDatas6 = typeDepts['配送'];
          that.deptDatas7 = typeDepts['安装'];
        }
      });
    }
  }), (0, _defineProperty2.default)(_methods, "changeEnabled", function changeEnabled(data, val) {
    var _this4 = this;

    this.$confirm('此操作将 "' + this.dict.label.user_status[val] + '" ' + data.username + ', 是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _user.default.edit(data).then(function (res) {
        _this4.crud.notify(_this4.dict.label.user_status[val] + '成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function () {
        data.enabled = !data.enabled;
      });
    }).catch(function () {
      data.enabled = !data.enabled;
    });
  }), (0, _defineProperty2.default)(_methods, "getRoles", function getRoles() {
    var _this5 = this;

    (0, _role.getAll)().then(function (res) {
      _this5.roles = res;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "getJobs", function getJobs() {
    var _this6 = this;

    (0, _job.getAllJob)().then(function (res) {
      _this6.jobs = res.content;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "getRoleLevel", function getRoleLevel() {
    var _this7 = this;

    (0, _role.getLevel)().then(function (res) {
      _this7.level = res.level;
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "checkboxT", function checkboxT(row, rowIndex) {
    return row.id !== this.user.id;
  }), (0, _defineProperty2.default)(_methods, "getDepts", function getDepts() {
    var _this8 = this;

    (0, _dept.getDepts)({
      enabled: true
    }).then(function (res) {
      _this8.depts = res.content.map(function (obj) {
        if (obj.hasChildren) {
          obj.children = null;
        }

        return obj;
      });
    });
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(depts) {
    var _this9 = this;

    var ids = [];
    depts.forEach(function (dept) {
      ids.push(dept.id);
    });
    (0, _dept.getDeptSuperior)(ids).then(function (res) {
      var date = res.content;

      _this9.buildDepts(date);

      _this9.depts = date;
    });
  }), (0, _defineProperty2.default)(_methods, "buildDepts", function buildDepts(depts) {
    var _this10 = this;

    depts.forEach(function (data) {
      if (data.children) {
        _this10.buildDepts(data.children);
      }

      if (data.hasChildren && !data.children) {
        data.children = null;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "loadDepts", function loadDepts(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      (0, _dept.getDepts)({
        enabled: true,
        pid: parentNode.id
      }).then(function (res) {
        parentNode.children = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 200);
      });
    }
  }), (0, _defineProperty2.default)(_methods, "save", function save() {
    var that = this;
    var allDeptData = {
      '推广': this.deptDatas0,
      '客服': this.deptDatas1,
      '资调': this.deptDatas12,
      '门店店长': this.deptDatas8,
      '门店导购': this.deptDatas2,
      '设计主管': this.deptDatas9,
      '设计对接人': this.deptDatas10,
      '设计师': this.deptDatas3,
      '效果图组主管': this.deptDatas13,
      '效果图组对接人': this.deptDatas14,
      '协助设计师': this.deptDatas11,
      '设计中心派单员': this.deptDatas4,
      '设计审单员': this.deptDatas5,
      '下单员': this.deptDatas15,
      '配送': this.deptDatas6,
      '安装': this.deptDatas7
    };

    _userLists.default.add({
      'id': this.userListsId,
      'type': 'USER',
      'userId': this.userId,
      'typeDepts': allDeptData
    }).then(function (res) {
      that.$notify({
        title: '修改成功',
        type: 'success',
        duration: 1500
      });
    });

    console.log(allDeptData);
  }), (0, _defineProperty2.default)(_methods, "validData", function validData() {
    if (this.deptDatas0.length > 0 || this.deptDatas1.length > 0 || this.deptDatas12.length > 0 || this.deptDatas8.length > 0 || this.deptDatas2.length > 0 || this.deptDatas9.length > 0 || this.deptDatas10.length > 0 || this.deptDatas3.length > 0 || this.deptDatas13.length > 0 || this.deptDatas14.length > 0 || this.deptDatas11.length > 0 || this.deptDatas4.length > 0 || this.deptDatas5.length > 0 || this.deptDatas15.length > 0 || this.deptDatas6.length > 0 || this.deptDatas7.length > 0) {
      return true;
    }

    return false;
  }), (0, _defineProperty2.default)(_methods, "getAllDeptData", function getAllDeptData() {
    return {
      '推广': this.deptDatas0,
      '客服': this.deptDatas1,
      '资调': this.deptDatas12,
      '门店店长': this.deptDatas8,
      '门店导购': this.deptDatas2,
      '设计主管': this.deptDatas9,
      '设计对接人': this.deptDatas10,
      '设计师': this.deptDatas3,
      '效果图组主管': this.deptDatas13,
      '效果图组对接人': this.deptDatas14,
      '协助设计师': this.deptDatas11,
      '设计中心派单员': this.deptDatas4,
      '设计审单员': this.deptDatas5,
      '下单员': this.deptDatas15,
      '配送': this.deptDatas6,
      '安装': this.deptDatas7
    };
  }), (0, _defineProperty2.default)(_methods, "resAllDeptData", function resAllDeptData(res) {
    console.log('resAllDeptData');
    console.log(res);
    var typeDepts = JSON.parse(res.typeDepts);
    this.deptDatas0 = typeDepts['推广'];
    this.deptDatas1 = typeDepts['客服'];
    this.deptDatas12 = typeDepts['资调'];
    this.deptDatas8 = typeDepts['门店店长'];
    this.deptDatas2 = typeDepts['门店导购'];
    this.deptDatas3 = typeDepts['设计师'];
    this.deptDatas13 = typeDepts['效果图组主管'];
    this.deptDatas14 = typeDepts['效果图组对接人'];
    this.deptDatas11 = typeDepts['协助设计师'];
    this.deptDatas9 = typeDepts['设计主管'];
    this.deptDatas10 = typeDepts['设计对接人'];
    this.deptDatas4 = typeDepts['设计中心派单员'];
    this.deptDatas5 = typeDepts['设计审单员'];
    this.deptDatas15 = typeDepts['下单员'];
    this.deptDatas6 = typeDepts['配送'];
    this.deptDatas7 = typeDepts['安装'];
    this.$notify({
      title: '同步完成',
      type: 'success',
      duration: 1500
    });
  }), (0, _defineProperty2.default)(_methods, "saveByUser", function saveByUser() {
    var _this11 = this;

    console.log('saveByUser');
    this.$confirm('是否确认往下推送权限给部门及用户？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _this11.validData();

      var that = _this11;

      if (that.validData()) {
        that.loading = true;

        _userLists.default.updateByUser({
          'id': _this11.userListsId,
          'type': 'DEPT',
          'deptId': _this11.deptId,
          'typeDepts': that.getAllDeptData()
        }).then(function (res) {
          console.log('updateByUser');
          console.log(res);
          that.deptId = res.deptId;
          that.userListsId = res.id;
          that.loading = false;
          that.$notify({
            title: '同步完成',
            type: 'success',
            duration: 1500
          });
        });
      } else {
        that.$notify({
          title: '请添加数据！',
          type: 'warning',
          duration: 1500
        });
      }
    });
  }), (0, _defineProperty2.default)(_methods, "saveByDept", function saveByDept() {
    console.log('saveByDept');
    var that = this;

    _userLists.default.updateByDept({
      'id': this.userListsId,
      'type': 'USER',
      'userId': this.userId,
      'typeDepts': that.getAllDeptData()
    }).then(function (res) {
      that.userId = res.userId;
      that.userListsId = res.id;
      that.resAllDeptData(res);
    });

    console.log(that.getAllDeptData());
  }), (0, _defineProperty2.default)(_methods, "deptSave", function deptSave() {
    var that = this;

    _userLists.default.deptAdd({
      'id': this.userListsId,
      'type': 'DEPT',
      'deptId': this.deptId,
      'typeDepts': that.getAllDeptData()
    }).then(function (res) {
      console.log('deptSave');
      console.log(res);

      if (res) {
        that.userListsId = res.id;
      }

      that.$notify({
        title: '修改成功',
        type: 'success',
        duration: 1500
      });
    });
  }), (0, _defineProperty2.default)(_methods, "reset", function reset() {
    this.userListsId = undefined;
    this.deptDatas0 = [];
    this.deptDatas1 = [];
    this.deptDatas12 = [];
    this.deptDatas8 = [];
    this.deptDatas2 = [];
    this.deptDatas3 = [];
    this.deptDatas13 = [];
    this.deptDatas14 = [];
    this.deptDatas11 = [];
    this.deptDatas9 = [];
    this.deptDatas10 = [];
    this.deptDatas4 = [];
    this.deptDatas5 = [];
    this.deptDatas6 = [];
    this.deptDatas7 = [];
  }), _methods)
};
exports.default = _default;